import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordUserDataClass } from './Pisa/pisaTimerecordUserDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordUser = pisaTimerecordUserDataClass(attributes)
